export const loadImg = (imgUrl = "") => {
  return new Promise(resolve => {
    if (!imgUrl) {
      window.console.error("请传入正确的图片链接")
      resolve(false)
      return
    }
    const img = new Image()
    img.src = imgUrl
    img.onload = () => {
      resolve(true)
    }
    img.onerror = () => {
      resolve(false)
    }
  })
}
